import {
  default as MuiFormLabel,
  FormLabelProps as MuiFormLabelProps
} from '@mui/material/FormLabel'
import { forwardRef } from 'react'

export type FormLabelProps = Pick<
  MuiFormLabelProps,
  | 'children'
  | 'color'
  | 'disabled'
  | 'error'
  | 'filled'
  | 'focused'
  | 'htmlFor'
  | 'id'
  | 'ref'
  | 'required'
>

export const FormLabel = forwardRef<HTMLLabelElement, FormLabelProps>(
  (props: FormLabelProps, ref): JSX.Element => <MuiFormLabel {...props} ref={ref} />
)

FormLabel.displayName = 'FormLabel'
